import React, { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import TrustLayout from "./TrustLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (message.trim().length < 5) {
      toast.error("Please write a short message.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, { name, email, message });
      setSent(true);
    } catch {
      toast.error("Could not send — please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <TrustLayout
      meta={{
        path: "/contact",
        kicker: "Say hello",
        title: "Contact My Centennial Plan | Centennial",
        description:
          "Questions, corrections, partnership ideas, or feedback about the free Centennial retirement calculator and guides — send us a message. A human reads every one.",
        h1: "Contact",
      }}
    >
      <p>
        Questions, corrections, media inquiries, partnership ideas, or just feedback — a human
        reads every message. Corrections to educational content are prioritized (see our
        corrections policy on the About page).
      </p>

      {sent ? (
        <div data-testid="contact-success" className="bg-[#E8F0EB] border border-[#2B5339] rounded-2xl p-6">
          <div className="font-medium text-[#2B5339]">Message received — thank you.</div>
          <p className="text-sm mt-1">We typically respond within a few business days.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="bg-white border border-[#E5E2DC] rounded-2xl p-6 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <label className="block">
              <span className="text-[10px] tracking-[0.18em] uppercase font-semibold text-[#5C6B62]">Name (optional)</span>
              <input
                data-testid="contact-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1.5 w-full bg-[#F9F8F6] border border-[#E5E2DC] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#2B5339]"
              />
            </label>
            <label className="block">
              <span className="text-[10px] tracking-[0.18em] uppercase font-semibold text-[#5C6B62]">Email (optional — for a reply)</span>
              <input
                data-testid="contact-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full bg-[#F9F8F6] border border-[#E5E2DC] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#2B5339]"
              />
            </label>
          </div>
          <label className="block">
            <span className="text-[10px] tracking-[0.18em] uppercase font-semibold text-[#5C6B62]">Message</span>
            <textarea
              data-testid="contact-message"
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="mt-1.5 w-full bg-[#F9F8F6] border border-[#E5E2DC] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#2B5339] resize-y"
            />
          </label>
          <button
            data-testid="contact-submit"
            type="submit"
            disabled={sending}
            className="bg-[#2B5339] text-white rounded-full px-6 py-2.5 text-sm hover:bg-[#1E3B28] disabled:opacity-50"
          >
            {sending ? "Sending…" : "Send message"}
          </button>
        </form>
      )}
    </TrustLayout>
  );
}
